import type { ReactNode } from 'react';

export const symbol_css: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M532-408v-53H414q-14 0-24-10t-10-24v-71q0-15 9.5-24.5T414-600h142q10 0 17 7t7 17q0 10-7 17t-17 7H428v53h118q14 0 24 10t10 24v71q0 15-9.5 24.5T546-360H404q-10 0-17-7t-7-17q0-10 7-17t17-7h128Zm260 0v-53H674q-14 0-24-10t-10-24v-71q0-15 9.5-24.5T674-600h142q10 0 17 7t7 17q0 10-7 17t-17 7H688v53h118q14 0 24 10t10 24v71q0 15-9.5 24.5T806-360H664q-10 0-17-7t-7-17q0-10 7-17t17-7h128Zm-638 48q-14 0-24-10t-10-24v-172q0-14 10-24t24-10h139q14 0 24 10t10 24v23q0 10-7 16.5t-17 6.5q-11 0-17.5-6.5T279-544v-8H168v144h111v-8q0-10 6.5-17t17.5-7q10 0 17 7t7 17v22q0 14-10 24t-24 10H154Z"
		/>
	</svg>
);
